import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

// Vue.mixin({
//     mounted() {
//         console.log('TRYING A MIXIN')
//     }
// })

// example of a global mixin

let app = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

global.vm = app;

//ga('set', 'page', router.currentRoute.path);
//ga('send', 'pageview');

//router.afterEach(( to, from ) => {
//    ga('set', 'page', to.path);
//    ga('send', 'pageview');
//});

Vue.use(VueAnalytics, {
    id: `${process.env.VUE_APP_GOOGLE_ANALYTICS_KEY}`, //'UA-110891996-2'
    router
});
